// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"285":"e2a39b08","362":"5f89c2d2","746":"73ea6128"}[chunkId] + ".chunk.js";
};